import React from "react";
import { Box, Typography } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";

import { setPharmaSubgroupFilter, selectPharmaSubgroupFilter } from "../../../store/uiSlice";
import subgroupsData from "../../../data/pharma/subgroups.json";

/**
 * Filtro de subgrupo compartido por las subvistas de Subgroups (Overview /
 * QoL / Adherence). Estado en Redux (uiSlice) para que se mantenga al
 * navegar entre ellas. "Todos los subgrupos" quita el filtro.
 */
function SubgroupFilterBar({ label }) {
    const { t } = useTranslation();
    const selected = useSelector(selectPharmaSubgroupFilter);
    const dispatch = useDispatch();

    const options = [{ id: "all", name: t("common.allSubgroups"), color: "gray500" }, ...subgroupsData.items];

    return (
        <Box sx={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: 0.75, mb: 2 }}>
            <Typography sx={{ fontSize: 11, color: "text.secondary", mr: 0.5 }}>{label || t("common.subgroupFilterLabel")}:</Typography>
            {options.map((opt) => {
                const active = selected === opt.id;
                return (
                    <Box
                        key={opt.id}
                        component="button"
                        type="button"
                        onClick={() => dispatch(setPharmaSubgroupFilter(opt.id))}
                        sx={{
                            fontFamily: "inherit",
                            fontSize: 11.5,
                            border: "1px solid",
                            borderColor: active ? "primary.main" : "divider",
                            bgcolor: active ? "primary.main" : "transparent",
                            color: active ? "#fff" : "text.secondary",
                            borderRadius: 999,
                            px: 1.25,
                            py: 0.4,
                            cursor: "pointer",
                            transition: "background-color 0.15s ease, color 0.15s ease",
                        }}
                    >
                        {opt.name}
                    </Box>
                );
            })}
        </Box>
    );
}

export function useSubgroupFilter() {
    const selected = useSelector(selectPharmaSubgroupFilter);
    const subgroups = subgroupsData.items;
    const filtered = selected === "all" ? subgroups : subgroups.filter((s) => s.id === selected);
    return { selected, subgroups, filtered };
}

export default SubgroupFilterBar;
